import BlockIcon from "@mui/icons-material/Block";
import Typography from "@mui/material/Typography";
import { Box, SvgIconProps } from "@mui/material";
import { ComponentType } from "react";

export default function EmptyStateCard({
  message = "No items",
  Icon = BlockIcon,
  iconSx,
}: {
  message?: string;
  Icon: ComponentType<SvgIconProps>;
  iconSx?: SvgIconProps["sx"];
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.015))",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(16px)",
        borderRadius: "15px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
        py: 3,
        px: 4,
        textAlign: "center",
        margin: "0 auto",
        width: "100%",
      }}
    >
      <Icon
        sx={{ fontSize: 64, color: "rgba(255,255,255,0.15)", mb: 2, ...iconSx }}
      />

      <Typography
        variant="body1"
        sx={{
          letterSpacing: 1,
          fontWeight: 300,
          textShadow: "none",
          mb: 1,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
